import { render } from "./TurkeyPage.vue?vue&type=template&id=817e72aa&scoped=true"
import script from "./TurkeyPage.vue?vue&type=script&lang=js"
export * from "./TurkeyPage.vue?vue&type=script&lang=js"

import "./TurkeyPage.vue?vue&type=style&index=0&id=817e72aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-817e72aa"]])

export default __exports__